export var getGoogleMapHeight = function getGoogleMapHeight(shouldBe200px) {
  return shouldBe200px ? '200px' : undefined;
};